import { PdfUserSettingsCategories } from 'modules/Shared/PdfPrint/usePdfUserSettings';

export const unitOverviewSettingsCategory: PdfUserSettingsCategories = {
	dealer: 'Default',
	customer: 'Default',
};
